export const navigationOptions = [
  { value: "dd-selection", label: "DD Selection", navigateTo: "/due-diligence/dd-selection" },
  { value: "ddq-dashboard", label: "DDQ Dashboard", navigateTo: "/due-diligence/ddq-dashboard" },
  { value: "ai-chat", label: "AI Chat", navigateTo: "/due-diligence/ai-chat" },
  { value: "analytics", label: "Analytics", navigateTo: "/due-diligence/analytics" },
  { value: "collaboration", label: "Collaboration", navigateTo: "/due-diligence/collaboration" },
  { value: "target-portal", label: "Target Portal", navigateTo: "/due-diligence/target-portal" },
];
